require('../../brokerPensionPlanContribution.scss');
require('./pensionPlanPeriodicSuccess.scss');

const PropTypes = require('prop-types');

// @vendor
const React = require('react');
const { formatText } = require('core/i18n').i18n;
const { withRouter } = require('react-router-dom');

// @commons
const WizardSuccess = require('components/commons/wizardSuccess/wizardSuccess');
const PensionPlanContributionSummary = require('components/broker/commons/pensionPlanContributionSummary/pensionPlanContributionSummary');
// @helpers
const {
    FIRST_STEP,
    BROKER_STOCKS_BUY_SELL_SUMMARY_BUY_MODIFIER
} = require('constants/index');

class pensionPlanPeriodicSuccess extends React.Component {

    constructor(props) {
        super(props);
        this.handleSecondaryClick = this.handleSecondaryClick.bind(this);
    }

    handleSecondaryClick() {
        const { history, immPensionPlanContribution } = this.props;
        const dataToEdit = immPensionPlanContribution.get('contributionDataEdit');
        const contractNumber = dataToEdit ? dataToEdit.getIn(['contrato','numerodecontrato']) : immPensionPlanContribution.get('contractNumber');
        history.replace('/myprofile/broker/ordersAndMovements/' + contractNumber);
    }

    render() {
        const { immPensionPlanContribution } = this.props;
        const successMessage = (!immPensionPlanContribution.get('isEditMode') ? formatText('pensionPlanContribution-periodicSuccessMessage') : formatText('pensionPlanContribution-periodicSuccessMessageEdit'));
        const isEditMode = immPensionPlanContribution.get('isEditMode');
        const mainButtonLabel = !isEditMode ? formatText('pensionPlanContribution-successMainButton') : formatText('pensionPlanContribution-successMainButtonEdit');
        const secondaryButtonLabel = formatText('pensionPlanContribution-successSecondaryButton');
        const step1 = immPensionPlanContribution.get('steps').get(FIRST_STEP);
        const plan = immPensionPlanContribution.get('pensionPlan');
        const walletPlan = immPensionPlanContribution.get('pensionPlanFromWallet');
        const chargeAccount = walletPlan.getIn(['contrato', 'fullContractNumber']);
        const planData = immPensionPlanContribution.get('extraordinaryData');
        const validationData = immPensionPlanContribution.get('validationData');
        const mainButtonUrl = !isEditMode ? '/myprofile/broker' : '/myprofile/broker/pensionPlanPeriodicalContribution';

        return (
            <div className="broker-pension-plan-periodic-contribution-success">
                <WizardSuccess
                    successMessage={successMessage}
                    customClassName="etfs-buy-success"
                    mainButton={{ label: mainButtonLabel, url: mainButtonUrl }}
                    secondaryButton={{ label: secondaryButtonLabel }}
                    onSecondaryButtonClick={this.handleSecondaryClick}
                >
                    <PensionPlanContributionSummary
                        productName={formatText('broker-etfProductName')}
                        plan={plan}
                        walletPlan={walletPlan}
                        planData={planData}
                        validationData={validationData}
                        planContractNumber={chargeAccount}
                        step1={step1}
                        modifier={BROKER_STOCKS_BUY_SELL_SUMMARY_BUY_MODIFIER}
                        columns={4}
                        isEditMode={isEditMode}
                    />
                </WizardSuccess>
            </div>
        );
    }
}

pensionPlanPeriodicSuccess.propTypes = {
    history: PropTypes.object.isRequired,
    immPensionPlanContribution: PropTypes.object.isRequired,
    immStocksContracts: PropTypes.object.isRequired
};

module.exports = withRouter(pensionPlanPeriodicSuccess);
